import React, { useState, useRef, useEffect } from "react";
import Lottie from 'lottie-react';
import "../styles/Navbar.css";
import hamburgerAnimation from '../assets/animations/Menu.json'

const Navbar = ({ scrollToSection }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const lottieRef = useRef();

  // Handle scroll to add background to navbar
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Toggle between menu open/close states
  const toggleMenu = () => {
    if (!isOpen) {
      lottieRef.current.goToAndPlay(0, true);
      setTimeout(() => {
        lottieRef.current.goToAndStop(17, true);
      }, calculateDuration(0, 17));
    } else {
      lottieRef.current.goToAndPlay(28, true);
    }
    setIsOpen(!isOpen);
  };

  // Calculate the duration to reach the frame based on the total duration and frame numbers
  const calculateDuration = (startFrame, endFrame) => {
    const totalFrames = 55;
    const totalDuration = 2000;
    const framesToPlay = endFrame - startFrame;
    const durationPerFrame = totalDuration / totalFrames;
    return framesToPlay * durationPerFrame;
  };

  const closeMenu = () => {
    lottieRef.current.goToAndPlay(28, true);
    setIsOpen(false);
  };

  // Combined function to scroll and close the menu
  const handleMenuClick = (sectionId) => {
    scrollToSection(sectionId);
    closeMenu();
  };

  return (
    <>
      {/* Desktop & Mobile Navbar */}
      <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
        <div className="navbar-container">
          <div className="navbar-logo" onClick={() => handleMenuClick('home')}>
            <span className="logo-text">HAMIDREZA</span>
          </div>

          {/* Desktop Menu */}
          <ul className="nav-menu">
            <li className="nav-menu-item active" onClick={() => handleMenuClick('home')}>
              Home
            </li>
            <li className="nav-menu-item" onClick={() => handleMenuClick('about')}>
              About Me
            </li>
            <li className="nav-menu-item" onClick={() => handleMenuClick('gallery')}>
              Projects
            </li>
            <li className="nav-menu-item" onClick={() => handleMenuClick('partners')}>
              Partners
            </li>
            <li className="nav-menu-item" onClick={() => handleMenuClick('contact')}>
              Contact
            </li>
          </ul>

          {/* Hamburger Menu Icon */}
          <div className="hamburger" onClick={toggleMenu}>
            <Lottie
              lottieRef={lottieRef}
              animationData={hamburgerAnimation}
              loop={false}
              autoplay={false}
              style={{ height: '40px', width: '40px' }}
              className="hamburger-animation"
            />
          </div>
        </div>
      </nav>

      {/* Full Screen Mobile Menu Overlay */}
      <div className={`menu-overlay ${isOpen ? "menu-open" : ""}`}>
        <ul className="navList">
          <li className="navItem" onClick={() => handleMenuClick('home')}>
            Home
          </li>
          <li className="navItem" onClick={() => handleMenuClick('about')}>
            About Me
          </li>
          <li className="navItem" onClick={() => handleMenuClick('gallery')}>
            Projects
          </li>
          <li className="navItem" onClick={() => handleMenuClick('partners')}>
            Partners
          </li>
          <li className="navItem" onClick={() => handleMenuClick('contact')}>
            Contact
          </li>
        </ul>
      </div>
    </>
  );
};

export default Navbar;
